module.exports = __webpack_public_path__ + "static/media/banesco-vial.20a2b82a.svg";